import get from "lodash/get";
import SearchTypesGenerator from "views/logic/searchtypes/SearchTypesGenerator";
const UpdateSearchForWidgets = (view) => {
  const { state: states } = view;
  const searchTypes = states.map((state) => SearchTypesGenerator(state.widgets));
  const search = get(view, "search");
  const newQueries = search.queries.map(
    (q) => {
      var _a, _b;
      return q.toBuilder().searchTypes((_b = (_a = searchTypes.get(q.id)) == null ? void 0 : _a.searchTypes) != null ? _b : []).build();
    }
  );
  const newSearch = search.toBuilder().newId().queries(newQueries.toOrderedSet()).build();
  let newView = view.toBuilder().search(newSearch).build();
  searchTypes.map(({ widgetMapping }) => widgetMapping).forEach((widgetMapping, queryId) => {
    const newStates = newView.state;
    if (states.has(queryId)) {
      newView = newView.toBuilder().state(newStates.update(queryId, (state) => state.toBuilder().widgetMapping(widgetMapping).build())).build();
    }
  });
  return newView;
};
export default UpdateSearchForWidgets;
